import { create } from "zustand";
import type {
	IDBPersistence,
	KeyValueStore,
	Persistence,
	RawClient,
} from "../lib/xmpp";

export type AccountStatus = "connecting" | "online" | "offline" | "error" | "auth";

export type AccountEntry = {
	client: RawClient;
	status: AccountStatus;
};

type CompositePersistence = Persistence & KeyValueStore;

interface AccountStore {
	accounts: Record<string, AccountEntry>;
	activeAccountId: string | null;
	persistence: CompositePersistence | null;
	idbp: IDBPersistence | null;
	addAccount: (jid: string, entry: AccountEntry) => void;
	setStatus: (jid: string, status: AccountStatus) => void;
	setActiveAccount: (jid: string) => void;
	setAccounts: (accounts: Record<string, AccountEntry> | ((prev: Record<string, AccountEntry>) => Record<string, AccountEntry>)) => void;
	setPersistence: (p: CompositePersistence, idbp: IDBPersistence) => void;
}

export const useAccountStore = create<AccountStore>((set) => ({
	accounts: {},
	activeAccountId: null,
	persistence: null,
	idbp: null,
	addAccount: (jid, entry) =>
		set((state) => ({
			accounts: { ...state.accounts, [jid]: entry },
		})),
	setStatus: (jid, status) =>
		set((state) => ({
			accounts: {
				...state.accounts,
				[jid]: { ...state.accounts[jid], status } as AccountEntry,
			},
		})),
	setActiveAccount: (jid) => set({ activeAccountId: jid }),
	setAccounts: (accounts) =>
		set((state) => ({
			accounts: typeof accounts === "function" ? accounts(state.accounts) : accounts,
		})),
	setPersistence: (persistence, idbp) => set({ persistence, idbp }),
}));
